

export enum TipoInformeCMF {
    MutuosHipotecariosOtorgados = "MUTUOS_HIPOTECARIOS_OTORGADOS",
    CambioAdministracionYEstado = "CAMBIO_ADMINISTRACION_Y_ESTADO",
    MutuosHipotecariosEndosados = "MUTUOS_HIPOTECARIOS_ENDOSADOS",
    TasacionesYRetasaciones = "TASACIONES_Y_RETASACIONES",
    TablasDeDesarrollo = "TABLAS_DE_DESARROLLO",
    Prepagos = "PREPAGOS",
    MutuosEnAdministracion = "MUTUOS_EN_ADMINISTRACION",
    InscripcionConservadorBienesRaices = "INSCRIPCION_EN_EL_CONSERVADOR_DE_BIENES_RAICES"
}

export interface RespuestaInformeCMFDTO{
    mutuoId: number,
    numeroOperacion: string,
    rut: string,
    nombre: string,
    plazo: number,
    monto: number
}

export interface Filtros{
    tipo: TipoInformeCMF
    fecha: Date
}

export interface GetNameFileResponseDto {
    fileName: string;
}